// extracted by mini-css-extract-plugin
var _1 = "ProductItem_clickableArea__SHfVc";
var _2 = "ProductItem_image__hMeIl";
var _3 = "ProductItem_item__-VbZt";
var _4 = "ProductItem_price__ZjoxR";
var _5 = "ProductItem_promotion__EunJL";
var _6 = "ProductItem_subtitle__AbLBM";
var _7 = "ProductItem_subtitleBold__yOPv0";
var _8 = "ProductItem_title__lv-zB";
export { _1 as "clickableArea", _2 as "image", _3 as "item", _4 as "price", _5 as "promotion", _6 as "subtitle", _7 as "subtitleBold", _8 as "title" }
